// assets
import { IconDashboard, IconListNumbers, IconBusinessplan } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconListNumbers, IconBusinessplan };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Home',
  type: 'group',
  children: [
    {
      id: '',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      icon: icons.IconDashboard,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
